class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    // Desktop pointers drive the menu by hover; coarse/no-hover devices keep tap-to-toggle.
    this.hoverQuery = window.matchMedia('(min-width: 990px) and (hover: hover)');
    this.closeTimer = null;

    this.addEventListener('mouseenter', this.onPointerEnter.bind(this));
    this.addEventListener('mouseleave', this.onPointerLeave.bind(this));
    // Block mouse clicks on the top-level item so a click doesn't toggle the
    // hovered menu shut. detail === 0 means a keyboard activation — leave those
    // alone so Enter/Space still opens the menu for keyboard users.
    this.summary.addEventListener('click', (event) => {
      if (this.hoverQuery.matches && event.detail !== 0) {
        event.preventDefault();
        // global.js flips aria-expanded on every summary click regardless of
        // the preventDefault above; re-sync it to the real open state after
        // its handler runs.
        setTimeout(() => this.summary.setAttribute('aria-expanded', this.mainDetailsToggle.hasAttribute('open')));
      }
    });
  }

  onPointerEnter() {
    if (!this.hoverQuery.matches) return;
    if (this.closeTimer) {
      clearTimeout(this.closeTimer);
      this.closeTimer = null;
    }
    this.closeSiblings();
    this.open();
  }

  onPointerLeave() {
    if (!this.hoverQuery.matches) return;
    // Brief delay so moving from the item into the panel doesn't close it.
    this.closeTimer = setTimeout(() => this.close(), 200);
  }

  open() {
    if (this.mainDetailsToggle.hasAttribute('open')) return;
    this.mainDetailsToggle.setAttribute('open', '');
    this.summary.setAttribute('aria-expanded', 'true');
  }

  // Close immediately: the panel fades in on open (animateMenuOpen) but has no
  // fade-out — detaching at once reverts to the closed opacity:0 state.
  close() {
    const details = this.mainDetailsToggle;
    if (!details.hasAttribute('open')) return;
    this.summary.setAttribute('aria-expanded', 'false');
    details.removeAttribute('open');
  }

  closeSiblings() {
    // Includes the search dropdown; close(false) keeps focus where it is.
    document.querySelectorAll('header-menu, header-search-modal').forEach((el) => {
      if (el !== this && typeof el.close === 'function') el.close(false);
    });
  }

  onToggle() {
    // The panel is a full-bleed sheet; base.css indents its list to this
    // variable so the children line up under the hovered item's text.
    if (this.mainDetailsToggle.open) {
      const textLeft = this.summary.getBoundingClientRect().left + parseFloat(getComputedStyle(this.summary).paddingLeft);
      this.mainDetailsToggle.style.setProperty('--bott-dropdown-item-text-left', `${textLeft}px`);
    }

    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
